module.exports = __webpack_public_path__ + "img/1502765577.51c1fc04.jpg";